import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import flatten from 'lodash/flatten';

import * as peopleActions from '../../people/people.actions';
import * as navigationActions from '../../navigation/navigation.actions';

import { ContentSection } from '../../layout/components';
import { PeopleList } from './';

class TeamList extends Component {
  onClick = slug => {
    const { navigate, people, populatePeopleModal } = this.props;
    const mergedPeeps = flatten(people.map(group => group.people));
    const populatePeeps =
      mergedPeeps.length === 0 ? [] : mergedPeeps.map(peep => peep.slug);
    populatePeopleModal(populatePeeps);
    navigate(`/team/${slug}`);
  };

  render() {
    const { people } = this.props;
    if (people.length === 0) return null;
    const sections = people.map(group => {
      const { slug, title, people } = group;
      return (
        <ContentSection key={slug} title={title}>
          <PeopleList items={people} onClick={this.onClick} />
        </ContentSection>
      );
    });

    return sections;
  }
}

TeamList.propTypes = {
  people: PropTypes.array.isRequired,
  populatePeopleModal: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {};
};

export default connect(
  mapStateToProps,
  Object.assign({}, navigationActions, peopleActions)
)(TeamList);



// WEBPACK FOOTER //
// ./src/modules/pages/components/TeamList.js